/* eslint-disable no-unused-vars */
import { Link, NavLink } from "react-router-dom";
import images from "../assets/images/assets";
import { useState, useContext, useEffect, useMemo } from "react";

// Context
import { ShopContext } from "./Context/ShopContext";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    showSearch,
    setShowSearch,
    getCartCount,
    navigate,
    token,
    setToken,
    setCartItems,
    name,
  } = useContext(ShopContext);

  // Safe First Letter Extraction
  const firstLetter = useMemo(() => {
    const userName = localStorage.getItem("userName");
    return userName ? userName.charAt(0).toUpperCase() : "";
  }, []);

  // Logout Handler
  const logOut = () => {
    localStorage.removeItem("token");
    setToken("");
    setCartItems({});
    navigate("/login");
  };

  const getNavLinkClass = ({ isActive }) =>
    isActive
      ? "text-white p-5 bg-prime-red transition2"
      : "hover:text-white p-5 hover:bg-prime-red transition2";

  const getNavStyles = ({ isActive }) =>
    isActive ? "font-bold text-blue-500 -translate-y-3" : "";

  // Prevent background scrolling when mobile nav is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    // Optionally, you might want to store the original overflow value
    // and restore it when the component unmounts to avoid potential issues.
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <header className="w-full bg-sec-white relative z-[9999]">
      <div className="container mx-auto px-4 py-5">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link
            to="/"
            className="tracking-tight text-lg 2xl:text-xl text-prime-red font-semibold hover:-translate-y-1 transition2"
          >
            it&#39;s all about cards.
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:block text-prime-red 2xl:text-lg">
            <ul className="flex gap-8 lg:gap-12">
              {["/", "/collections", "/story", "/contact"].map((path, i) => (
                <li key={i} className="hover:-translate-y-1 transition2">
                  <NavLink to={path} className={getNavStyles}>
                    {["Home", "Collections", "Our story", "Contact Us"][i]}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          {/* Right Side Icons */}
          <div className="flex items-center gap-4">
            {/* Search */}
            <img
              src={images.search}
              alt="search"
              className="w-5 md:w-6 cursor-pointer"
              onClick={() => setShowSearch(!showSearch)}
            />

            {/* Profile Section */}
            <div className="relative group">
              {token ? (
                <div className="w-10 h-10 bg-pink-400 text-white text-lg uppercase flex items-center justify-center rounded-full">
                  {firstLetter}
                </div>
              ) : (
                <img
                  src={images.profile_icon}
                  alt="profile"
                  className="w-5 cursor-pointer"
                  onClick={() => navigate("/login")}
                />
              )}

              {/* Dropdown */}
              {token && (
                <div className="hidden group-hover:block absolute -right-2 pt-2 shadow-lg shadow-zinc-300/50 z-50">
                  <div className="w-36 bg-zinc-50 text-zinc-500 flex flex-col rounded-lg overflow-hidden">
                    <div className="px-4 py-3 cursor-pointer hover:text-zinc-100 hover:bg-zinc-800 transition2 border-b">
                      My Profile
                    </div>
                    <p
                      onClick={() => navigate("/orders")}
                      className="px-4 py-3 cursor-pointer hover:text-zinc-100 hover:bg-zinc-800 transition2 border-b"
                    >
                      Orders
                    </p>
                    <p
                      onClick={logOut}
                      className="px-4 py-3 cursor-pointer hover:text-zinc-100 hover:bg-zinc-800 transition2 border-b"
                    >
                      Logout
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Cart */}
            <Link to="/cart" className="relative group">
              <img src={images.cart} alt="cart" className="w-7 md:w-8" />
              <span className="absolute w-3.5 h-3.5 -bottom-0.5 right-0 bg-rose-500 text-white text-[10px] flex items-center justify-center rounded-full">
                {getCartCount()}
              </span>
            </Link>

            {/* Hamburger Menu */}
            <img
              src={images.menu_icon}
              alt="menu"
              className="w-7 md:w-8 md:hidden"
              onClick={() => setIsOpen(!isOpen)}
            />
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <div
        className={`absolute md:hidden top-0 w-full h-screen bg-zinc-50 backdrop-blur-lg transition-transform duration-300 ease-in-out z-[9999] flex flex-col justify-between ${
          isOpen ? "translate-x-0" : "translate-x-[1500px]"
        }`}
      >
        {/* Mobile Header */}
        <div className="flex items-center h-20 border-b border-prime-red ">
          <button
            className="flex items-center p-4 gap-2"
            onClick={() => setIsOpen(false)}
          >
            <img src={images.back_icon} alt="back" className="w-8" />
            <p className="text-lg text-prime-red">Back</p>
          </button>
        </div>

        {/* Mobile Links */}
        <div className="flex flex-1 flex-col text-prime-red pb-4 ">
          {["/", "/collections", "/story", "/contact"].map((path, i) => (
            <NavLink to={path} key={i} className={getNavLinkClass}>
              <button className="text-xl w-full">
                {["Home", "Collections", "Our Story", "Contact Us"][i]}
              </button>
            </NavLink>
          ))}
        </div>
        {/* Footer */}
        <div className="text-center text-sm pt-8 pb-8 text-zinc-500">
          &copy; {new Date().getFullYear()}{" "}
          <span className="font-semibold ">itsallaboutcards</span> All rights
          reserved.
        </div>
      </div>
    </header>
  );
};

export default Header;
